// extracted by mini-css-extract-plugin
module.exports = {"panel":"panel_panel__3H1yn","hover-typeB-r":"panel_hover-typeB-r__1Yjdc"};